module.exports = __webpack_public_path__ + "static/media/uoa-22.e138f182.jpg";